import React from "react";

import { tokens } from "@ovou-inc/ovou-ui/tokens";
import { FiInfo } from "react-icons/fi";
import { Typography } from "@mui/material";

const EmailMissing = ({
  isEnrichmentCompletedWithoutEmail,
  canEnrich,
}: {
  isEnrichmentCompletedWithoutEmail: boolean;
  canEnrich: boolean;
}) => {
  return (
    <Typography
      sx={{
        fontSize: "12px",
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        lineHeight: 1,
        marginLeft: "10px",
      }}
    >
      <FiInfo
        style={{ marginRight: 6 }}
        color={tokens.color.feedback.error}
        size={18}
      />
      {isEnrichmentCompletedWithoutEmail ? (
        <>No email was found.</>
      ) : (
        <>
          <Typography
            component="span"
            sx={{
              fontSize: "12px",
              fontWeight: "600",
              color: tokens.color.feedback.error,
              marginRight: "3px",
            }}
          >
            Email missing.
          </Typography>
          {canEnrich && "Enrich required."}
        </>
      )}
    </Typography>
  );
};

export default EmailMissing;
